import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {Q9HtmlDecoderPipe} from '@q9elements/ui-kit/common';

import {AdditionalSyncStatusesComponent} from './components/additional-sync-statuses/additional-sync-statuses.component';
import {NodePathComponent} from './node-path.component';

@NgModule({
  imports: [CommonModule, MatTooltipModule, Q9HtmlDecoderPipe, TranslateModule],
  declarations: [NodePathComponent, AdditionalSyncStatusesComponent],
  exports: [NodePathComponent]
})
export class NodePathModule {}
